module.exports = __webpack_public_path__ + "img/kechuang.b795bf06.png";